<template>
    <div>
        <el-row>
            <h2>部门管理列表</h2>
        </el-row>
        <el-row>
            <el-col>
                <el-button @click="addDepartment">新增</el-button>
            </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
            <el-col>
                <el-table :data="departmentData" border stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="80" min-width="80"></el-table-column>
                    <el-table-column prop="DEPARTMENT_NAME" label="部门名称" ></el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="200">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="openEdit(scope.row)" icon="el-icon-edit">修改
                            </el-button>
                            <el-button type="text" size="small" icon="el-icon-check" style="color:#67C23A"
                                       @click="startDepartment(scope.row)" v-if="scope.row.STATUS === 0">启用
                            </el-button>
                            <el-button type="text" size="small" icon="el-icon-close" style="color:  #F56C6C"
                                       @click="stopDepartment(scope.row)" v-else>禁用
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog title="修改部门信息" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
                    <el-form :model="editForm" ref="editForm" :label-width="formLabelWidth">
                        <el-form-item label="部门名称：" prop="NAME">
                            <el-input v-model="editForm.DEPARTMENT_NAME"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="close()">取 消</el-button>
                        <el-button @click="submitEdit()">确 定</el-button>
                    </div>
                </el-dialog>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog title="新增部门" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
                    <el-form :model="addForm" ref="addForm" :label-width="formLabelWidth">
                        <el-form-item label="部门名称：" prop="NAME">
                            <el-input v-model="addForm.DEPARTMENT_NAME"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="close()">取 消</el-button>
                        <el-button @click="submitAdd()">确 定</el-button>
                    </div>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      // loading:false,
      departmentData: [],
      editFormVisible: false,
      addFormVisible: false,
      editForm: {},
      addForm: {},
      formLabelWidth: '100px',
    };
  },
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      const params = {
        SERVICE_ID: '10012',
        OTYPE: 5,
        TC_ID: Number(sessionStorage.getItem('companyId')),
      };
      http.post(params).then((result) => {
        this.departmentData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.emp = JSON.parse(JSON.stringify(row.DEPARTMENT_NAME));
    },
    submitEdit() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10012',
            OTYPE: 2,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            DEPARTMENT_NAME: this.editForm.DEPARTMENT_NAME,
            DEPARTMENT_ID: this.editForm.DEPARTMENT_ID,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    startDepartment(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10012',
            OTYPE: 4,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            DEPARTMENT_ID: row.DEPARTMENT_ID,
            STATUS: 1,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '启用成功', type: 'success' });
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    stopDepartment(row) {
      this.$confirm('您确定禁用该部门吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10012',
          OTYPE: 3,
          TC_ID: Number(sessionStorage.getItem('companyId')),
          DEPARTMENT_ID: row.DEPARTMENT_ID,
          STATUS: 0,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '禁用成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    addDepartment() {
      this.addFormVisible = true;
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const params = {
            SERVICE_ID: '10012',
            OTYPE: 1,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            DEPARTMENT_NAME: this.addForm.DEPARTMENT_NAME,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.queryList();
            // this.loading = false
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    close() {
      this.editForm.DEPARTMENT_NAME = this.emp;
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.editForm = {};
      this.addForm = {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/departmentManage.vue